import { useMutation } from '@tanstack/react-query'

import { requestSending } from '@src/api'
import { DefaultApiRequestSendingRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useRequestSending = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiRequestSendingRequest) =>
      requestSending(axiosInstance, params),
  })
}
